const videos = document.querySelectorAll(".sr-video-gallery__video video");
const videosContainer = document.querySelectorAll(".sr-video-gallery__video");

videosContainer.forEach((videoContainer) => {
  const playIcon = videoContainer.querySelector(".play-icon");
  playIcon.addEventListener("click", function () {
    const clickedVideo = videoContainer.querySelector("video");
    if (clickedVideo.paused) {
      // Pause all videos before playing the clicked one
      videos.forEach((video) => {
        if (video !== clickedVideo && !video.paused) {
          video.pause();
          const playIcon = video
            .closest(".sr-video-gallery__video")
            .querySelector(".play-icon");
          playIcon.classList.remove("play-icon-active");
        }
      });

      clickedVideo.play(); // Play the clicked video if it's paused
      playIcon.classList.add("play-icon-active");
    } else {
      clickedVideo.pause(); // Pause the clicked video if it's playing
      playIcon.classList.remove("play-icon-active");
    }
  });
});
